import React from "react";
import { useSelector } from "react-redux";
import { StakingButton } from "../style";

function StakingPools() {
  const { projectNamePoolName } = useSelector((state) => state.global);
  return (
    <StakingButton>
      <a
        href={projectNamePoolName?.pool_staking_url}
        target="#"
        style={{ fontSize: "16px" }}
      >
        Staking Pools
      </a>
    </StakingButton>
  );
}

export default StakingPools;
